import { Button } from '../ui/Button';
import { cn } from '../../utils/cn';
import { MOBILE_STICKY_BOTTOM_CLASS } from './mobileLayoutConstants';

/**
 * Barra de acção primária fixa acima do bottom nav + FAB (só mobile).
 */
export function StickyPageAction({ children, className }) {
  return (
    <div
      className={cn(
        'fixed inset-x-0 z-20 bg-transparent px-4 py-3 md:hidden',
        MOBILE_STICKY_BOTTOM_CLASS,
        className,
      )}
    >
      {children}
    </div>
  );
}

export function StickyPageActionButton({ children, className, ...props }) {
  return (
    <Button type="button" className={cn('w-full', className)} {...props}>
      {children}
    </Button>
  );
}
